import { makeStyles } from '@material-ui/core';
import { BookingType } from './BookingType';
import { Client } from './Client';
import { Provider } from './Provider';
import { StatusCard } from './StatusCard';
import { StatusCardPreflight } from './StatusCardPreflight';

const useStyles = makeStyles(theme => ({
}));
const BookingDetailCard = ({ booking, loading, goToProfile = () => { }, enableMessaging }) => {
  const classes = useStyles()
  return (
    <>
      <BookingType booking={booking} loading={loading} />
      {((booking?.is_whitelabel && !booking?.isConfirmed) || !booking?.is_whitelabel) && (
        <Client
          onReschedule={null}
          userLocation={booking?.user_location} client={booking?.client} booking={booking}
        />
      )}
      <StatusCard booking={booking} />
      <StatusCardPreflight booking={booking} />
      <Provider
        screen="Booking Details"
        provider={booking?.provider}
        header asCard
        compact
        disableDetails
        enableMessaging={enableMessaging}

        onClickProfile={() => goToProfile()} />
    </>
  )
}

export { BookingDetailCard };
